import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import extend from "lodash/extend";
import { assignIn } from "lodash";
import EventUtil from "../utils/EventUtil";
import EventActions from "../actions/EventActions";
import EventBucketActions from "../actions/EventBucketActions";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";
import UserStore from "../stores/UserStore";
import { history } from "../util";
class EventStore {
  constructor() {
    this.bindActions(EventActions);

    this.state = {
      events: {},
      availability: {},
      isFetching: false,
      newEventId: null
    };

    this.exportPublicMethods({
      getEventById: this.getEventById.bind(this),
      getTicketBucketWithEventById: this.getTicketBucketWithEventById.bind(
        this
      ),
      getEventsForEventBucket: this.getEventsForEventBucket.bind(this),
      getEventsForVenue: this.getEventsForVenue.bind(this)
    });
  }

  getEventById(id) {
    return this.state.events[id];
  }

  getTicketBucketWithEventById(ticketBucketId) {
    let event = values(this.state.events).find(e =>
      e.ticket_buckets.some(b => b.id === ticketBucketId)
    );
    if (event) {
      let bucket = Object.assign(
        {},
        event.ticket_buckets.find(b => b.id === ticketBucketId)
      );
      bucket.event = event;
      return bucket;
    }
    return null;
  }

  getEventsForEventBucket(id) {
    return values(this.state.events).filter(function(p) {
      return p.event_bucket === id;
    });
  }

  getEventsForVenue(id) {
    return values(this.state.events).filter(function(p) {
      return p.venue.id === id;
    });
  }

  onFetchOne(id) {
    this.setState({ isFetching: true });
    EventUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        EventActions.updateEvent(id, data);
        this.setState({ isFetching: false });
      })
      .catch(EventActions.fetchFailed);
  }

  onFetchAllForBucket(options) {
    this.setState({ isFetching: true });
    EventUtil.fetchAllForBucket(
      UserStore.getState().apiKey,
      options.eventBucketId,
      options.includeScanCounts,
      options.excludeOlderEvents
    )
      .then(data => {
        EventActions.updateEvents(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(EventActions.fetchFailed);
  }

  onFetchAllForVenueInBucket(options) {
    this.setState({ isFetching: true });
    EventUtil.fetchAllForVenueInBucket(
      UserStore.getState().apiKey,
      options.venueId,
      options.eventBucketId,
      options.includeScanCounts
    )
      .then(data => {
        EventActions.updateEvents(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(EventActions.fetchFailed);
  }

  onFetchAvailability(options) {
    EventUtil.fetchAvailability(
      UserStore.getState().apiKey,
      options.eventBucketId,
      options.eventIds
    )
      .then(data => {
        this.setState(prevState => {
          const newAvailability = assignIn(
            this.state.availability,
            data.ticketBucketAvailability
          );

          return {
            ...prevState,
            availability: newAvailability
          };
        });
      })
      .catch(err => {
        console.error("Failed to fetch availability:", err);
        GlobalNotificationActions.notify.defer(
          `Failed to fetch availability: ${err.message}`
        );
      });
  }

  onEdit(newData) {
    EventUtil.edit(
      UserStore.getState().apiKey,
      newData.id,
      newData.values,
      newData.applyRecurring
    )
      .then(data => {
        EventActions.updateEvent(newData.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        GlobalNotificationActions.notify.defer(
          `All changes saved successfully.`
        );
      })
      .catch(EventActions.editFailed);
  }

  onEditImage({ id, field, file }) {
    this.setState({ uploadingImageField: field });
    EventUtil.editImage(UserStore.getState().apiKey, id, field, file)
      .then(data => {
        EventActions.updateEvent(id, data);
        this.setState({ uploadingImageField: null });
      })
      .catch(EventActions.editFailed);
  }

  onDelete({ id, applyRecurring }) {
    EventUtil.delete(UserStore.getState().apiKey, id, applyRecurring)
      .then(data => {
        const bucket = this.state.events[id].event_bucket;
        const isVirtual = this.state.events[id].is_virtual;

        EventBucketActions.fetchOne(bucket);
        EventActions.updateEvent(id, undefined);
        EventActions.fetchAllForBucket(bucket);
        history.push(
          `/event_buckets/${bucket}${
            isVirtual ? "/virtual_festival" : "/events"
          }`
        );
      })
      .catch(EventActions.editFailed);
  }

  onCreate(newData) {
    this.setState({
      newEventId: null
    });

    EventUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        EventActions.updateEvent(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newEventId: data.id
        });
      })
      .catch(EventActions.editFailed);
  }

  onDuplicate(id) {
    this.setState({
      newEventId: null
    });

    EventUtil.duplicate(UserStore.getState().apiKey, id)
      .then(data => {
        EventActions.updateEvent(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newEventId: data.id
        });
      })
      .catch(EventActions.editFailed);
  }

  onUpdateEvent(data) {
    if (!data.event) {
      delete this.state.events[data.id];
    } else {
      this.state.events[data.id] = data.event;
    }
    this.state.newEventId = null;
    this.setState(this.state);
  }

  onUpdateEvents(events) {
    this.setState(prevState => {
      const newEvents = assignIn(this.state.events, events);
      return {
        ...prevState,
        events: newEvents
      };
    });
  }

  onFetchFailed(e) {
    console.error("Fetching event failed:", e);
    GlobalNotificationActions.notify.defer(
      `Fetching event failed: ${e.message}`
    );
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);

    // trigger event update to allow resubmit
    this.state.events[e._event].updated_at = Date.now();
    this.setState({ events: this.state.events });
  }
}

export default alt.createStore(EventStore, "EventStore");



// WEBPACK FOOTER //
// ./src/app/stores/EventStore.js